import { useState, useEffect } from 'react';

// Backend convention: 0=Monday, 1=Tuesday, ..., 6=Sunday
const DAYS = [0, 1, 2, 3, 4, 5, 6]; // Monday through Sunday

function DaySelector({ onChange, daysOfTheWeek = [], getDayName }) {
  const [selected, setSelected] = useState(daysOfTheWeek);

  useEffect(() => {
    setSelected(daysOfTheWeek || []);
  }, [daysOfTheWeek]);

  const toggle = (day) => {
    const newSelected = selected.includes(day)
      ? selected.filter((d) => d !== day)
      : [...selected, day].sort((a, b) => a - b);

    setSelected(newSelected);
    onChange?.(newSelected.length ? newSelected : undefined);
  };

  // Get first letter of day name for display
  const getDayLabel = (dayIndex) => {
    if (getDayName) {
      return getDayName(dayIndex).charAt(0).toUpperCase();
    }
    // Fallback to English
    return ['M', 'T', 'W', 'T', 'F', 'S', 'S'][dayIndex];
  };

  return (
    <div className="flex gap-1">
      {DAYS.map((day) => (
        <button
          key={day}
          type="button"
          onClick={() => toggle(day)}
          data-testid={`day-btn-${day}`}
          className={`
            w-9 h-9 rounded-full font-medium text-sm transition-colors
            ${
              selected.includes(day)
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }
          `}
        >
          {getDayLabel(day)}
        </button>
      ))}
    </div>
  );
}

export { DaySelector };

export default function Demo() {
  const [value, setValue] = useState(undefined);

  return (
    <div className="p-8 flex flex-col items-center gap-6">
      <DaySelector onChange={setValue} daysOfTheWeek={[1, 2]} />
      <div className="text-sm text-gray-500">
        Value:{' '}
        <span className="font-mono font-bold text-gray-900">
          {value ? `[${value.join(', ')}]` : 'undefined'}
        </span>
      </div>
    </div>
  );
}
